import React, { useState } from "react";
import { Box, Typography, Button, ButtonGroup } from "@mui/material";
import TitleHeaders from "../../../Components/CluppForms/TitleHeaders";
import { CheckCircle, Info } from "@mui/icons-material";
import CluppDropdown from "../../../Components/CluppForms/CluppDropdown";
import cuoponExample1 from "../../../Assets/CouponExplanation1.jpg";
import cuoponExample2 from "../../../Assets/CouponExplanation2.jpg";

const Upsell = ({ state }) => {
  const [deviceView, setDeviceView] = useState("celular"); // Estado para el botón activo

  return (
    <Box>
      <TitleHeaders
        title={`Buenas noticias para ti ${state.userName} 😉`}
        subtitle={
          <Typography variant="subtitle1">
            Si piensas asegurar otro vehículo, te ofrecemos un{" "}
            <strong>15% de descuento</strong> solo si lo contratas en
            periodicidad mensual.
          </Typography>
        }
        isRequired={false}
      />

      <Typography variant="body1" gutterBottom color="#000">
        Para obtener el descuento es importante que sepas esto:
      </Typography>

      <Box
        sx={{
          textAlign: "left",
          margin: "0 auto",
          padding: 2,
          borderRadius: "8px",
          backgroundColor: "#FFFFFF",
          boxShadow: 2,
        }}
      >
        <Typography variant="body1" gutterBottom color="#000">
          <Info
            sx={{ verticalAlign: "middle", marginRight: 1, color: "#00BBEE" }}
          />
          Es importante que lo des de alta antes de cancelar (da click en{" "}
          <strong>“mantener el seguro”</strong>)
        </Typography>
        <Typography variant="body1" gutterBottom color="#000">
          <CheckCircle
            sx={{ verticalAlign: "middle", marginRight: 1, color: "#00BBEE" }}
          />
          Contrata en periodicidad mensual
        </Typography>

        <CluppDropdown
          notBox={true}
          title={<strong>Pasos para dar de alta un nuevo vehículo:</strong>}
          startIcon={
            <CheckCircle
              sx={{ verticalAlign: "middle", marginRight: 1, color: "#00BBEE" }}
            />
          }
          description={
            <>
              <ol>
                <li>Ingresa a tu app y da click en “+ agregar seguro”</li>
                <li>
                  Te llevará al cotizador y te dará el cupón de descuento que
                  deberás ingresar más adelante.
                </li>
                <li>Sigue el proceso para contratar seleccionando periodicidad mensual.</li>
                <li style={{marginBottom: "20px"}}>
                  Al momento de que te solicite ingresar los datos de tu tarjeta para el pago, es donde debes ingresar el cupón del 15% de descuento (ejemplo, ver las imágenes).
                  
                  {/* Botones para cambiar la imagen */}
                  <ButtonGroup variant="outlined" sx={{ marginTop: 2, marginBottom: 2 }} disableElevation>
                    <Button

                      onClick={() => setDeviceView("celular")}
                      variant={deviceView === "celular" ? "contained" : "outlined"}
                    >
                      Desde celular
                    </Button>
                    <Button
                      onClick={() => setDeviceView("computadora")}
                      variant={deviceView === "computadora" ? "contained" : "outlined"}
                    >
                      Desde computadora
                    </Button>
                  </ButtonGroup>

                  {/* Contenedor para mostrar la imagen seleccionada */}
                  <div style={{ marginTop: "10px", display: "flex" }}>
                    {deviceView === "celular" ? (
                      <img
                        src={cuoponExample1}
                        alt="Ejemplo de cupón desde celular"
                        style={{ width: "100%", maxWidth: "200px", height: "auto", marginBottom: "10px" }}
                      />
                    ) : (
                      <img
                        src={cuoponExample2}
                        alt="Ejemplo de cupón desde computadora"
                        style={{ width: "100%", maxWidth: "400px", height: "auto" }}
                      />
                    )}
                  </div>
                </li>
                <li>En caso de no querer contratar solo debes salir de la página.</li>
              </ol>
            </>
          }
        />
      </Box>
    </Box>
  );
};

export default Upsell;